import React from "react";
import { formatMarathiDate } from "@/lib/documentUtils";
import { T } from "@/context/MarathiEditContext";

export const AddressMemoMarathi = React.forwardRef(function AddressMemoMarathi(
  { data },
  ref,
) {
  const {
    caseNo, courtName, courtPlace, party1Name, party2Name, party1Role, party2Role, date, partyAddresses = [],
    advocateAppearingFor, advocateAppearingNumber,
  } = data;
  const mrDate = formatMarathiDate(date);
  const appearLabel = advocateAppearingFor
    ? `${advocateAppearingFor}${
        advocateAppearingNumber && String(advocateAppearingNumber).trim()
          ? ` No. ${String(advocateAppearingNumber).trim()}`
          : ""
      }`
    : "";

  const validRows = partyAddresses.filter(
    (p) => (p.name && p.name.trim()) || (p.address && p.address.trim()),
  );

  return (
    <div ref={ref} className="a4-sheet mr-doc memo-sheet" data-testid="address-memo-mr-doc">
      <h1 className="doc-title mr-title">पत्ता मेमो</h1>

      <div className="memo-case-row">
        <div className="memo-case-spacer" />
        <div className="memo-case-no-right" data-testid="memo-mr-case-no">
          <T source={caseNo} placeholder="___________" />
        </div>
      </div>

      <div className="mr-court-block">
        <h2 className="doc-court-heading mr-court-left">
          मे.&nbsp;<T source={courtName} placeholder="________________________" />
          {courtPlace && String(courtPlace).trim() ? (
            <>,&nbsp;<T source={courtPlace} placeholder="___________" /></>
          ) : null}
        </h2>
        <h3 className="doc-court-at mr-court-right-in-block">यांचे कोर्टात...</h3>
      </div>

      <div className="party-block">
        <div className="pb-row">
          <div className="pb-name"><T source={party1Name} placeholder="____________________" /></div>
          <div className="pb-brace">{"}"}</div>
          <div className="pb-role">
            वादी / अर्जदार
            <br />
            अपीलकर्ता / फिर्यादी
          </div>
        </div>
        <div className="pb-vs-row">
          <div className="pb-vs-inner">विरुद्ध</div>
        </div>
        <div className="pb-row">
          <div className="pb-name"><T source={party2Name} placeholder="____________________" /></div>
          <div className="pb-brace">{"}"}</div>
          <div className="pb-role">
            प्रतिवादी / वि.प.
            <br />
            रिस्पॉन्डंट / आरोपी
          </div>
        </div>
      </div>

      <p className="memo-preamble doc-intro-line">
        यातील&nbsp;<T source={appearLabel} placeholder="प्रतिवादी" />&nbsp;यांचा पत्ता मेमो पुढीलप्रमाणे
      </p>

      <table className="memo-table" data-testid="address-memo-mr-table">
        <thead>
          <tr>
            <th>नांव व पत्ता</th>
            <th style={{ width: "32%" }}>सही</th>
          </tr>
        </thead>
        <tbody>
          {validRows.length === 0 ? (
            <tr>
              <td>
                <div style={{ fontWeight: 600 }}>
                  <T source={party2Name} placeholder="____________________" />
                </div>
                <div>रा. ____________________________________________</div>
              </td>
              <td className="sig-cell">&nbsp;</td>
            </tr>
          ) : (
            validRows.map((p, idx) => (
              <tr key={idx}>
                <td>
                  <div style={{ fontWeight: 600 }}>
                    <T source={p.name} placeholder="____________________" />
                  </div>
                  <div style={{ whiteSpace: "pre-wrap" }}>
                    <T source={p.address} placeholder="____________________" />
                  </div>
                </td>
                <td className="sig-cell">&nbsp;</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <p className="memo-preamble" style={{ marginTop: 12 }}>
        येणेप्रमाणे पत्ता मेमो असे.
      </p>

      <h3 className="memo-verification-title">प्रतिज्ञा</h3>
      <p className="memo-verification-body">
        मी/आम्ही सत्य प्रतिज्ञेवर कथन करतो की वरील पत्ता मेमो मधील संपूर्ण मजकूर
        माझे / आमचे माहिती व समजुतीप्रमाणे खरा व बरोबर आहे. पत्त्याबाबत बदल
        झालेस तो मी / आम्ही कळवीन. म्हणून केली प्रतिज्ञा.
      </p>

      <div className="memo-place-date" data-testid="memo-mr-place-date">
        <div><T source={courtPlace} placeholder="____________" /></div>
        <div>दि.&nbsp;{mrDate}</div>
      </div>

      {/* Signature area: verified names on the RIGHT side, only after
          successful verification (at least one row filled). No horizontal
          line — names only. */}
      {validRows.length > 0 ? (
        <div className="memo-signatures" data-testid="memo-mr-verified-names">
          {validRows.map((p, idx) => (
            <div key={idx} className="memo-sig-block">
              <div className="memo-sig-name">
                <T source={p.name} placeholder="____________________" />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="memo-blank-sign" data-testid="memo-mr-blank-signature">
          <div className="memo-blank-sign-line" />
        </div>
      )}
    </div>
  );
});

export default AddressMemoMarathi;
